//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory5Lang', {
//        templateUrl: 'views/components/views/textileModelCategory5Lang/textileModelCategory5Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory5LangService', function ($stateParams, stateService, textileModelCategory5LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory5Keyno = $stateParams.textilemodelcategory5_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory5Languages() {
//                vm.model.inputListLanguages = await textileModelCategory5LangService.listTextileModelCategory5Languages({ textilemodelcategory5_keyno: textileModelCategory5Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory5LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory5Languages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
